export default "__VITE_ASSET__CZUoZhZF__"